import {store} from './../../redux/';
import { call, put } from 'redux-saga/effects';
import { url } from './../../services/Url';
import CONSTANTS from '../../util/constants';
import APICallingService from '../../services/APICallingService';


const getDoorCheckWorkSheetAPI = () => {

    let doorAPI = url.createDoorWorksheet;

    return APICallingService.sendRequestForGet(doorAPI, (res) => {

    }, true);

}

function* getDoorCheckWorkSheet() {

    try {

        let s = store.getState();


        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getDoorCheckWorkSheetAPI);
        if (response && response != null) {

            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.GET_DOOR_CHECK_WORKSHEET_API_SUCCESS, payload: { value: response.data }
            })
            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });

        }
        else {
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.GET_DOOR_CHECK_WORKSHEET_API_SUCCESS, payload: { value: 'Failed' }
            })
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.GET_DOOR_CHECK_WORKSHEET_API_SUCCESS, payload: { value: 'Failed' }
        })
    }


}

const getLotCheckWorkSheetAPI = (action) => {

 
    let lotAPI =  url.createLotWorksheet;
    let payload;
    if (action?.lot_id) {
        payload = {
            lot_id:  action.lot_id
        }
    }
    else {
        payload = {
            division_id:  action.division_id
        }
    }
    // return APICallingService.sendRequestForGet(lotAPI, (res) => {

    // }, true);

    console.log("payload",payload);

    return APICallingService.sendRequestForPostWithAuth(lotAPI, payload, false, (res) => {

    }, true);


}

function* getLotCheckWorkSheet(action) {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getLotCheckWorkSheetAPI, action.payload.value);
        if (response && response != null) {

            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });

            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.GET_LOT_CHECK_WORKSHEET_API_SUCCESS, payload: { value: response.data }
            })

        }
        else {
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.GET_LOT_CHECK_WORKSHEET_API_SUCCESS, payload: { value: [] }
            })
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.GET_LOT_CHECK_WORKSHEET_API_SUCCESS, payload: { value: [] }
        })
    }


}

const doorBulkAPI = (action) => {

    return APICallingService.sendRequestForPostWithAuth(url.doorBulk, action, false, (res) => {

    }, true);

}

function* doorBulk(action) {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(doorBulkAPI, action.payload.value);
        if (response && response != null && response.data) {
            alert('Data imported Successfully')
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.DOOR_BULK_API_SUCCESS, payload: { value: response.data }
            })
            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });

        }
        else {
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.DOOR_BULK_API_SUCCESS, payload: { value: 'Failed' }
            })
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.DOOR_BULK_API_SUCCESS, payload: { value: 'Failed' }
        })
    }


}

const spacesBulkAPI = (action) => {

    return APICallingService.sendRequestForPostWithAuth(url.spaceBulk, action, false, (res) => {

    }, true);

}

function* spacesBulk(action) {

    try {

        let s = store.getState();
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });
        const response = yield call(spacesBulkAPI, action.payload.value);
        if (response && response != null) {

            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.SPACE_BULK_API_SUCCESS, payload: { value: response.data }
            })
            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });

        }
        else {
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.SPACE_BULK_API_SUCCESS, payload: { value: 'Failed' }
            })
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.DOOR_BULK_API_SUCCESS, payload: { value: 'Failed' }
        })
    }


}


const lotsBulkAPI = (action) => {

    return APICallingService.sendRequestForPostWithAuth(url.lotsBulk, action, false, (res) => {

    }, true);

}

function* lotsBulk(action) {

    try {

        let s = store.getState();
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });
        const response = yield call(lotsBulkAPI, action.payload.value);
        if (response && response != null && response.data) {
            alert('Data imported Successfully')
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.LOTS_BULK_API_SUCCESS, payload: { value: response.data }
            })
            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });

        }
        else {
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.LOTS_BULK_API_SUCCESS, payload: { value: 'Failed' }
            })
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.DOOR_BULK_API_SUCCESS, payload: { value: 'Failed' }
        })
    }


}

const divisionBulkAPI = (action) => {

    return APICallingService.sendRequestForPostWithAuth(url.divisionBulk, action, false, (res) => {

    }, true);

}

function* divisionBulk(action) {

    try {

        let s = store.getState();
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });
        const response = yield call(divisionBulkAPI, action.payload.value);
        if (response && response != null && response.data) {
            alert('Data imported Successfully')
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.DIVISION_BULK_API_SUCCESS, payload: { value: response.data }
            })
            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });

        }
        else {
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.DIVISION_BULK_API_SUCCESS, payload: { value: 'Failed' }
            })
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.DIVISION_BULK_API_SUCCESS, payload: { value: 'Failed' }
        })
    }


}

const userBulkAPI = (action) => {

    return APICallingService.sendRequestForPostWithAuth(url.userBulk, action, false, (res) => {

    }, true);

}

function* userBulk(action) {

    try {

        let s = store.getState();
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });
        const response = yield call(userBulkAPI, action.payload.value);
        if (response && response != null && response.data) {
            alert('Data imported Successfully')
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.USER_BULK_API_SUCCESS, payload: { value: response.data }
            })
            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });

        }
        else {
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.USER_BULK_API_SUCCESS, payload: { value: 'Failed' }
            })
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.USER_BULK_API_SUCCESS, payload: { value: 'Failed' }
        })
    }


}

const trailerBulkAPI = (action) => {

    return APICallingService.sendRequestForPostWithAuth(url.trailerBulk, action, false, (res) => {
    }, true);
}

function* trailerBulk(action) {

    try {

        let s = store.getState();
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });
        const response = yield call(trailerBulkAPI, action.payload.value);
        if (response && response != null && response.data) {
            alert('Data imported Successfully')
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.TRAILER_BULK_API_SUCCESS, payload: { value: response.data }
            })
            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });

        }
        else {
            if (response && response != null && response.Status != 405) {

                yield put({
                    type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.TRAILER_BULK_API_SUCCESS, payload: { value: 'Failed' }
                })
            }
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.TRAILER_BULK_API_SUCCESS, payload: { value: 'Failed' }
        })
    }
}

const createReportsAPI = (value) => {

    let payload = {
        "fromDate": value.fromDate,
        "toDate": value.toDate,
        "division_id":value.division_id
    }

    return APICallingService.sendRequestForPostWithAuth(url.createReports, payload, false, (res) => {
    }, true);


}

function* createReports(action) {
    try {
        let s = store.getState();
        
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(createReportsAPI, action.payload.value);

        if (response && response?.callBackStatus.toLowerCase() == 'success') {

            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.CREATE_REPORTS_API_SUCCESS, payload: { value: response.data }
            })

        }
        else {
            if (response && response != null && response.Status != 405) {

                yield put({ type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.CREATE_REPORTS_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {

        yield put({ type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.CREATE_REPORTS_API_SUCCESS, payload: { value: 'Failed' } });

    }


}


function* updatePDFData(action) {

    try {
        let s = store.getState();
        let lotWorkSheetData = s.workSheet.getLotCheckWorkSheet;
        let doorWorkSheetData = s.workSheet.getDoorCheckWorkSheet;
        if (action?.payload?.value?.data && action.payload.value.data.lotName) {
            lotWorkSheetData[action.payload.value.index].Correct = action?.payload?.value?.data?.Correct;
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.GET_LOT_CHECK_WORKSHEET_API_SUCCESS, payload: { value: lotWorkSheetData }
            })
        }
        else if (action?.payload?.value?.data && action.payload.value.data.doorType) {
            doorWorkSheetData[action.payload.value.index].Correct = action?.payload?.value?.data?.Correct;
            yield put({
                type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.GET_DOOR_CHECK_WORKSHEET_API_SUCCESS, payload: { value: doorWorkSheetData }
            })
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.GET_DOOR_CHECK_WORKSHEET_API_SUCCESS, payload: { value: 'Failed' }
        })
    }


}

export { getLotCheckWorkSheet, getDoorCheckWorkSheet, doorBulk, createReports, lotsBulk, spacesBulk, divisionBulk, userBulk, trailerBulk, updatePDFData };
